import script from "./esTagList.vue?vue&type=script&setup=true&lang=ts"
export * from "./esTagList.vue?vue&type=script&setup=true&lang=ts"

import "./esTagList.vue?vue&type=style&index=0&id=d2f4e2b6&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d2f4e2b6"]])

export default __exports__